import {
	BaseError,
} from './BaseError';

export class PostOfferSearchError extends BaseError {
	constructor(message: string, stack?: string) {
		super(message, stack);
	}
}
